import { Text } from '@chakra-ui/react';

import { useValidationSchema } from '../hooks';
import type { ItemPath } from 'api/quote-marketplace';

interface MarketRequiredIndicatorProps {
  itemPath: ItemPath;
  fieldPath: string;
  entity?: Record<string, unknown>;
}

const MarketRequiredIndicator = ({
  itemPath,
  fieldPath,
  entity,
}: MarketRequiredIndicatorProps) => {
  const { getMarketsRequiringField } = useValidationSchema();

  const markets = getMarketsRequiringField(itemPath, fieldPath, entity);

  if (!markets || markets.length === 0) {
    return null;
  }

  return (
    <Text fontSize="xs" color="red.600" mt={0.5}>
      Required by: {markets.join(', ')}
    </Text>
  );
};

export default MarketRequiredIndicator;
